import { render, staticRenderFns } from "./boldplay-frame.vue?vue&type=template&id=48d6d8b5"
import script from "./boldplay-frame.vue?vue&type=script&lang=js"
export * from "./boldplay-frame.vue?vue&type=script&lang=js"
import style0 from "./boldplay-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/boldplay/boldplay-frame.vue
// module id = fpJo
// module chunks = 0